import BaseAPI from "../base";

class WorkService extends BaseAPI {
  //
  getWorkAddInit() {
    return this.get({
      url: "/YuanHe/Work/WorkAddInit",
    });
  }

  // 获取某一个工单类型对应的需要加载的表单控件列表
  getWorkAddControl(params) {
    return this.post({
      url: "/YuanHe/Work/WorkAddLoadControl",
      data: params,
    });
  }

  // 获取工单处理组列表
  getWorkProcessGroup(params) {
    return this.get({
      url: "/YuanHe/Work/WorkProcessGroup",
      data: params,
    });
  }

  // 钉钉根据code拿用户信息
  getWorkDingAuth(params) {
    return this.post({
      url: "/YuanHe/Work/WorkDingAuth",
      data: params,
    });
  }

  // 工单提交
  workAdd(params, url = null) {
    return this.post({
      url: url || "/YuanHe/Work/WorkAdd",
      data: params,
    });
  }

  // 工单列表
  workMyWorkList(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkList",
      data: params,
    });
  }

  // 工单详情
  workMyWorkDetail(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkDetail",
      data: params,
    });
  }

  // 工单详情-附件-添加
  workMyWorkDetailFileAdd(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkDetailFileAdd",
      data: params,
    });
  }

  // 工单详情-评论和处理
  workMyWorkDetailComment(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkDetailComment",
      data: params,
    });
  }

  // 根据guid修改工单受理状态接口
  workAcceptStatusEdit(params) {
    return this.post({
      url: "/YuanHe/Work/WorkAcceptStatusEdit",
      data: params,
    });
  }

  // 工单详情-添加处理人-检索
  workMyWorkDetailProcessUserSearch(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkDetailProcessUserSearch",
      data: params,
    });
  }

  // 工单详情-添加处理人
  workMyWorkDetailProcessUserAdd(params) {
    return this.post({
      url: "/YuanHe/Work/WorkMyWorkDetailProcessUserAdd",
      data: params,
    });
  }

  // 工单详情-添加处理人
  getStartDate(params, url) {
    return this.post({
      url: url,
      data: params,
    });
  }

  // 工单查询（用于关联工单的检索）
  workExtListSearch(params) {
    return this.post({
      url: "/YuanHe/Work/WorkExtListSearch",
      data: params,
    });
  }

  // 关联工单
  WorkRelate(params) {
    return this.post({
      url: "/YuanHe/Work/WorkRelate",
      data: params,
    });
  }

  // 通话记录
  WorkContactLog(params) {
    return this.post({
      url: "/YuanHe/Work/WorkContactLog",
      data: params,
    });
  }

  // 联系客户
  WorkContactCustomer(params) {
    return this.post({
      url: "/YuanHe/Work/WorkContactCustomer",
      data: params,
    });
  }

  // 退回转发人
  workRollback(params) {
    return this.post({
      url: "/YuanHe/Work/WorkRollback",
      data: params,
    });
  }

  // 工单相关枚举
  workGetEnum(params) {
    return this.get({
      url: "/YuanHe/Work/WorkGetEnum",
      data: params,
    });
  }

  // 修改客户证件类型和证件号
  workEditCustomerId(params) {
    return this.post({
      url: "/YuanHe/Work/WorkEditCustomerId",
      data: params,
    });
  }

  // 受理组列表
  workGetAcceptGroupList(params) {
    return this.post({
      url: "/YuanHe/Work/WorkGetAcceptGroupList",
      data: params,
    });
  }

  // 分配受理组
  workAssignAcceptGroup(params) {
    return this.post({
      url: "/YuanHe/Work/WorkAssignAcceptGroup",
      data: params,
    });
  }

  // 受理人列表
  workGetAcceptUserList(params) {
    return this.post({
      url: "/YuanHe/Work/WorkGetAcceptUserList",
      data: params,
    });
  }

  // 更改受理人
  workAssignAcceptUser(params) {
    return this.post({
      url: "/YuanHe/Work/WorkAssignAcceptUser",
      data: params,
    });
  }

  // 给工单打标签
  workLabel(params) {
    return this.post({
      url: "/YuanHe/Work/WorkLabel",
      data: params,
    });
  }

  // 钉钉预约查询API
  workGetHisApppointmentList(params) {
    return this.post({
      url: "http://drclub.circleharmonyhealth.com/DataCenterPro/YuanHe/WorkCustomComponents/WorkGetHisApppointmentList",
      data: params,
    });
  }

  // 权益
  rightsByIdNo(params) {
    return this.post({
      url: process.env.VUE_APP_RIGHTS,
      data: params,
    });
  }

  // 获取工单标签列表
  workLabelList(params) {
    return this.post({
      url: "/YuanHe/Work/WorkLabelList",
      data: params,
    });
  }

  // 修改外送时间
  workEditWaisongDate(params) {
    return this.post({
      url: "/YuanHe/Work/WorkEditWaisongDate",
      data: params,
    });
  }

  // 根据 { ding_user_id  } 获取
  workUserGet(params) {
    return this.post({
      url: "/YuanHe/Work/WorkUserGet",
      data: params,
    });
  }

  // 圆和绿通工单操作节点列表
  getLutongNodeList(params) {
    return this.get({
      url: "/YuanHe/Work/GetLutongNodeList",
      data: params,
    });
  }

  // 圆和绿通供应商列表
  getLutongSupplierList(params) {
    return this.get({
      url: "/YuanHe/Work/GetLutongSupplierList",
      data: params,
    });
  }

  //
  getProductPriceByChannel(params) {
    return this.post({
      url: "/YuanHe/Work/GetProductPriceByChannel",
      data: params,
    });
  }
}

export default new WorkService();
